/** LaunchDarkly / product channel for copy-generator context (email vs SMS). */
export type CopyGeneratorChannel = 'email' | 'sms';

export type ChatMessageRole = 'assistant' | 'user';

export type ChatMessage = {
    content: string;
    role: ChatMessageRole;
};

export type CopyGeneratorChatState = {
    channel: CopyGeneratorChannel;
    messages: ChatMessage[];
};

/** Mint fill for user outgoing bubbles (Figma: Other/Mint #E0F3F0). */
export const COPY_GENERATOR_USER_BUBBLE_BG = '#E0F3F0';

/**
 * API `errorCode` when the org has not completed brand registration for AI copy tools.
 * Matches backend: `{ "message": "Brand not registered", "errorCode": "638bbb87-6a99-4ad0-933d-2ec972cfb817" }`
 */
export const COPY_GENERATOR_ERROR_CODE_BRAND_NOT_REGISTERED = '638bbb87-6a99-4ad0-933d-2ec972cfb817';

/** Figma Content-Builder / Other — Water (empty-state panel). */
export const COPY_GENERATOR_BRAND_REQUIRED_PANEL_BG = '#EBF2FE';
